import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import FaqComponents from "../../components/common/faq";
import { SAPin } from "../../../../app-constants";

const faqs = [
  {
    question: " How much does it cost to make an app in Saudi Arabia?",
    answer: ` <p>Developing a web application involves ensuring its accessibility through a web browser. Leveraging common web technologies such as HTML, CSS, and JavaScript enhances the cost-efficiency of web app development. The expenses associated with creating a web application in Saudi Arabia can vary between SAR 15,000 and SAR 150,000.</p>
        <p>In KSA mobile app development, native apps are designed exclusively for iOS or Android devices. Given the specialized expertise and resources required, native app development typically has the highest costs. The expenses for native app development in Saudi Arabia can range from SAR 75,000 to SAR 750,000, based on the app's complexity and features.</p>
        <p>On the other hand, hybrid apps function seamlessly on both iOS and Android platforms. Leveraging cross-platform development tools and frameworks, hybrid apps generally present a more cost-effective alternative to native apps. In Saudi Arabia, the cost of developing hybrid apps can vary between SAR 35,000 and SAR 350,000, depending on the scale of the project.s</p>`,
  },
  {
    question: "Which app works in Saudi Arabia?",
    answer: `<p>WhatsApp, a widely adopted messaging application, provides a chat feature, and its popularity extends not only in Saudi Arabia but also across the globe, rendering it an excellent option for maintaining connectivity. However, the voice and video calling of these applications are banned in the region due to regulatory protocols. Other social media applications like Instagram, Facebook, and Snapchat are also quite popular in the KSA.</p>`,
  },
  {
    question: "How long will it take to develop an app in Saudi Arabia?",
    answer: ` <p>The timeline of every project may vary depending on the scope and other relevant aspects of the applications. Meanwhile, the estimated development time for a basic-level mobile app development in Saudi Arabia is almost 6 months. The creation of a full-fledged application can take up to 1 year.</p>`,
  },
  {
    question:
      "Why Should I Choose TekRevol over other companies in Saudi Arabia?",
    answer: `  <p>One of the major reasons for choosing TekRevol over other mobile app development companies in Saudi Arabia is that you’ll get comprehensive digital solutions tailored to your needs.</p>
        <p>With years of experience, our team of professionals is dedicated to creating innovative and secure apps that are easy to use and maintain. Our commitment to quality and excellence ensures that you get the best app development experience. Furthermore, we provide cost-effective services, so that you can expect the best value for your money.</p>`,
  },
  {
    question:
      " I already have an idea - How can I start my app journey with TekRevol?",
    answer: `<p>If you have an idea to present, you are in the right place to start your app development journey. To begin with TekRevol, simply fill out a form or contact our live agents. Our team of experts will promptly respond to your queries regarding your app. Our skilled professionals will attentively listen to all your questions and concerns and provide effective solutions in a timely manner.</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div className="faq_loc p-100 tekrevol_dark_bg">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>Frequently Asked Questions</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col xs={12} md={12} lg={8} xl={7} xxl={7} className="services_faqs">
            <FaqComponents faqs={faqs} />
          </Col>
          <Col xs={12} md={12} lg={4} xl={4} xxl={4} className="offset-xl-1">
            <div className="map_loc">{SAPin}</div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
